export function formatCurrency(
  value: number | string | null | undefined,
  decimals: number = 2
): string {
  if (value === null || value === undefined || value === '') {
    return '-';
  }

  const num = Number(
    typeof value === 'string' ? value.replace(/,/g, '') : value
  );

  if (Number.isNaN(num)) {
    return '-';
  }

  const formatted = num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return `$${formatted}`;
}

export function formatPriceRange(
  minPrice: number | string | null | undefined,
  maxPrice: number | string | null | undefined
): string {
  return `${formatCurrency(minPrice)} - ${formatCurrency(maxPrice)}`;
}
